import { render, staticRenderFns } from "./WarnContactDeleted.vue?vue&type=template&id=72c9fdda&scoped=true&"
import script from "./WarnContactDeleted.vue?vue&type=script&lang=js&"
export * from "./WarnContactDeleted.vue?vue&type=script&lang=js&"
import style0 from "./WarnContactDeleted.vue?vue&type=style&index=0&id=72c9fdda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9fdda",
  null
  
)

export default component.exports